/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  CurveLPTokensMagician128,
  CurveLPTokensMagician128Interface,
} from "../CurveLPTokensMagician128";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ICurveLPTokensDetailsFetchersRepository",
        name: "_fetchersRepository",
        type: "address",
      },
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_priceProvidersRepository",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "InvalidCurvePriceProviderLPTokenPair",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidFetchersRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidOrNotSupportedLPToken",
    type: "error",
  },
  {
    inputs: [],
    name: "Unsupported",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "coin",
        type: "address",
      },
    ],
    name: "Cached",
    type: "event",
  },
  {
    inputs: [],
    name: "FETCHERS_REPO",
    outputs: [
      {
        internalType: "contract ICurveLPTokensDetailsFetchersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_COINS",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "QUOTE_TOKEN",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "poolCoins",
    outputs: [
      {
        internalType: "address",
        name: "coin",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "index",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pools",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "towardsAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsNative",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type CurveLPTokensMagician128ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CurveLPTokensMagician128ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CurveLPTokensMagician128__factory extends ContractFactory {
  constructor(...args: CurveLPTokensMagician128ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "CurveLPTokensMagician128";
  }

  deploy(
    _fetchersRepository: string,
    _priceProvidersRepository: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<CurveLPTokensMagician128> {
    return super.deploy(
      _fetchersRepository,
      _priceProvidersRepository,
      overrides || {}
    ) as Promise<CurveLPTokensMagician128>;
  }
  getDeployTransaction(
    _fetchersRepository: string,
    _priceProvidersRepository: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _fetchersRepository,
      _priceProvidersRepository,
      overrides || {}
    );
  }
  attach(address: string): CurveLPTokensMagician128 {
    return super.attach(address) as CurveLPTokensMagician128;
  }
  connect(signer: Signer): CurveLPTokensMagician128__factory {
    return super.connect(signer) as CurveLPTokensMagician128__factory;
  }
  static readonly contractName: "CurveLPTokensMagician128";
  public readonly contractName: "CurveLPTokensMagician128";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CurveLPTokensMagician128Interface {
    return new utils.Interface(_abi) as CurveLPTokensMagician128Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveLPTokensMagician128 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurveLPTokensMagician128;
  }
}
